export const isCarsDomain = () => {
  const host = window.location.hostname;
  return host === 'cars.runtheraysintl.com' || host === 'www.cars.runtheraysintl.com';
};

export const carPath = (path) => {
  if (isCarsDomain()) {
    // On cars domain: /cars/login -> /login, /cars/admin -> /admin, /cars/slug -> /slug
    return path.replace(/^\/cars/, '') || '/';
  }
  return path;
};
